<template>
  <SpotlightGroupItems :items="documents">
    <template #item="props">
      <SpotlightDocumentGroupItem :item="props.item" @on-item-click="onItemClick" />
    </template>
  </SpotlightGroupItems>
</template>

<script>
import { SpotlightGroup } from '@/modules/spotlight/models/SpotlightGroup';
import { Document } from '@/modules/document/models/Document';
import SpotlightGroupItems from '@/modules/spotlight/components/presentational/SpotlightGroupItems.vue';
import { EstateDetailsCollapsesTabValue } from '@/modules/ops/constants/EstateDetailsCollapsesTabValue';
import { EstateDetailsShowConfig } from '@/modules/core/ui/models/EstateDetailsShowConfig';
import EstateDetailsService from '@/modules/core/ui/services/EstateDetailsService';
import SpotlightDocumentGroupItem from '@/modules/spotlight/components/stateful/SpotlightDocumentGroupItem.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightDocumentGroup',
  emits: ['on-item-click'],
  components: { SpotlightDocumentGroupItem, SpotlightGroupItems },
  props: {
    group: SpotlightGroup
  },
  static: {
    EstateDetailsCollapsesTabValue
  },
  computed: {
    documents() {
      return Document.mapModels(this.group.items);
    }
  },
  methods: {
    onItemClick(item) {
      this.$emit('on-item-click', item);
      EstateDetailsService.show(
        new EstateDetailsShowConfig({
          component: this,
          modelId: item.estateId,
          tab: EstateDetailsCollapsesTabValue.RELATED
        })
      );
    }
  }
};
</script>
